import React from 'react'
import { styled } from '../../stitches.config';
import Timer from '../common/Timer';

const BridSideInfo = props => {
    const { article, disableVote } = props;

    const time = new Date(`${article.time}`);
    const isoTime = new Date(`${article.iso_date}`);
    const currentDate = new Date();

    const progress = Math.round(isoTime.getTime() / currentDate.getTime() * 100) || 0;
    const partnerFixedProgress = Math.round(isoTime.getTime() / time.getTime() * 100) || 0;

    return (
        <BoxWrapper>
            <Root>
                {!!article.titleTop && <b className="brid-side-info-title">{article.titleTop}</b>}
                {!!article.title && <p>{article.title}</p>}
                {!!article.label && <span>
                    {article.label}
                </span>}
                <span>{!!disableVote || <VoteTitle>Do końca głosowania zostało:<br /></VoteTitle>}
                    <WrapperTimer className="brid-side-info-timer"><Timer finishTime={article.time} /></WrapperTimer>
                    <ProgressBar
                        css={{ "$$fixedProgress": partnerFixedProgress }}
                    //progress={progress - partnerFixedProgress} 
                    />
                </span>
            </Root>
        </BoxWrapper>
    )
}

const BoxWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    color: "#272424",
    padding: "0 14px",
    "b:first-of-type": {
        fontSize: "24px",
        lineHeight: "30px",
        fontWeight: 700,
        marginBottom: "8px",
        "@bp5": {
            fontSize: "38px",
            lineHeight: "42px"
        }
    },
    "p": {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: 600,
        margin: "0",
        color: "#8D8D8D",
        marginBottom: "24px"
    },
    "span": {
        display: "block",
        fontWeight: 300,
        color: "#8D8D8D",
        "&:first-of-type": {
            fontSize: "14px"
        },
        "&:last-of-type": {
            fontSize: "18px"
        },
        "p": {
            marginBottom: "0"
        },
        "b": {
            color: "#ed2024"
        }
    },
    "@bp4": {
        alignItems: "center",
        height: "394px",
        paddingRight: "30px",
        paddingLeft: "12px"
    }
});

const Root = styled("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    ".brid-side-info-title": {
        color: "$grayscale100"
    },
    ".brid-side-info-timer": {
        color: "$grayscale100 !important"
    }
});
const VoteTitle = styled("p", {
    fontSize: "14px !important",
    lineHeight: "10px"
});
const WrapperTimer = styled("p", {
    fontWeight: "600 !important",
    fontSize: "14px !important",
    lineHeight: "10px"
});

const ProgressBar = styled("div", {
    position: "relative",
    width: "auto",
    height: "4px",
    borderRadius: "5px 0 0 5px",
    margin: "16px 0px 24px",
    backgroundColor: "#e1e1e1",
    "&:before": {
        content: "",
        position: "absolute",
        top: "0",
        left: "0",
        width: "$$fixedProgress",
        height: "4px",
        borderRadius: "5px 0 0 5px",
        backgroundColor: "$primary",
        border: "1px solid",
        borderColor: "$primary"
    },
    "@bp4": {
        margin: "0"
    }
});

export default BridSideInfo